import Marionette from 'backbone.marionette';
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import NotificationListView from '@/views/notification_list';
import notification_dropdown_template from '@/../templates/notification-dropdown.hbs';

const NotificationDropdownView = Marionette.View.extend({
    template: Handlebars.compile(notification_dropdown_template),
    regions: {
        notificationList: '.notification-list-region',
        notificationDropdown : '@ui.notification_dropdown',
    },
    ui: {
        badge: '.badge',
        notification_dropdown: '.notification-dropdown',
    },
    tagName: 'div',
    className: 'dropdown',
    collectionEvents: {
        'change': 'render'
    },
    onRender : function() {
        this.showChildView(
            'notificationList', 
            new NotificationListView({ collection: new Backbone.Collection(this.collection.slice(0, 5))})
        );
    },
});

export default NotificationDropdownView;
